module.exports = __webpack_public_path__ + "static/media/a.42f3f462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/starPilots/a.png
// module id = 2090
// module chunks = 0